module.exports = __webpack_public_path__ + "img/xtnl-110.626be1dc.jpg";